import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import AnimatedLogo from "./AnimatedLogo";
import { APP_VERSION, BUILD_DATE } from "../version";

export default function AnimatedFooter({ variant = "default" }) {
  const bgClass = variant === "transparent" 
    ? "bg-transparent" 
    : variant === "dark" 
      ? "bg-slate-900/80 backdrop-blur-sm" 
      : "bg-card/80 backdrop-blur-sm";
  
  const textClass = variant === "dark" || variant === "transparent"
    ? "text-white/60"
    : "text-muted-foreground";

  return (
    <footer className={`${bgClass} py-4 sm:py-6 w-full`}>
      <div className="w-full px-4 sm:px-6 flex flex-col items-center justify-center">
        <div className="flex items-center justify-center gap-2">
          <span className={`text-xs sm:text-sm ${textClass}`}>Propulsé par</span>
          <AnimatedLogo 
            linkTo="/" 
            showAnimation={true} 
            size="small"
            variant={variant === "dark" || variant === "transparent" ? "light" : "default"}
          />
        </div>
        <p className={`text-xs ${textClass} mt-2 text-center`}>
          La plateforme de tirages au sort et sondages
        </p>
        <p className={`text-[10px] ${textClass} mt-2 opacity-60 text-center`}>
          v{APP_VERSION} • Déployé le {BUILD_DATE}
        </p>
      </div>
    </footer>
  );
}
